/**
 * Returns true when the app is running as the public live-share (vehicle
 * location tracking) view, which is served from the `tracking.` subdomain
 * (see `LIVE_SHARE` in mt-shared's public-url-access).
 *
 * This page is anonymous and unauthenticated, so cookie-setting product
 * scripts such as Pendo must not load there: they enlarge the cookie header
 * sent to the tracking host — which, for accounts with large cookie jars,
 * overflows the server's header-size limit and breaks the page (HTTP 431) —
 * and they have no visitor to identify. See TSSD-32472.
 */
export function isLiveShareView(hostname: string = window.location.hostname): boolean {
  return hostname.startsWith('tracking.');
}
